import ProtectedRoute from "routes/ProtectedRoute";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

const previewRoutes = [
  {
    path: "briefcase-preview/:spaceId",
    loader: protectedRouteLoader,
    lazy: async () => {
      const mod = await import(
        "views/Admin/Briefcase/BriefcasePreview/BriefcasePreview"
      );
      const BriefcasePreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <BriefcasePreview />
          </ProtectedRoute>
        ),
      };
    },
  },

  {
    path: "document-preview/:documentId",
    loader: protectedRouteLoader,
    lazy: async () => {
      const mod = await import("views/Admin/Workspace/DocumentPreview");
      const DocumentPreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <DocumentPreview />
          </ProtectedRoute>
        ),
      };
    },
  },

  {
    path: "events/preview/:eventId",
    loader: protectedRouteLoader,
    lazy: async () => {
      const mod = await import("components/Admin/Events/EventsPreview");
      const EventsPreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <EventsPreview />
          </ProtectedRoute>
        ),
      };
    },
  },

  {
    path: "events/preview/:eventId/:sessionId",
    loader: protectedRouteLoader,
    lazy: async () => {
      const mod = await import("components/Admin/Events/EventsPreview");
      const EventsPreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <EventsPreview />
          </ProtectedRoute>
        ),
      };
    },
  },

  {
    path: "events/document-preview/:eventId/:documentId",
    loader: protectedRouteLoader,
    lazy: async () => {
      const mod = await import("components/Admin/Events/EventDocumentPreview");
      const EventDocumentPreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <EventDocumentPreview />
          </ProtectedRoute>
        ),
      };
    },
  },
];

export default previewRoutes;
